import React from 'react';
import './animation047.less';

interface IAnimation047Props {
  columns: any[];
  data: any[];
  className?: string | null;
  tip: string;
}

const Animation047: React.FunctionComponent<IAnimation047Props> = ({
  columns,
  data,
  className,
  tip,
}) => {
  return (
    <div className={`component animation047 ${className}`}>
      <div
        className="animation047-left"
        dangerouslySetInnerHTML={{ __html: tip }}
      />
      <div className="animation047-right">
        <div className="animation047-title">
          {columns.map((x, idx) => (
            <div className={`subtitle subtitle${idx}`} key={idx + 1}>
              <div className="subtitle-content" key={`title${idx}`}>
                {x.link ? (
                  <a href={x.link} target="blank">
                    {x.title}
                  </a>
                ) : (
                  <>{x.title}</>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="animation047-content">
          {data.map((x, index) => (
            <div
              key={`content${index}`}
              className={`animation047-item animation047-item${index}`}
            >
              {columns.map((col, colIndex) => (
                <div
                  className="sub-item"
                  key={`${index}-${colIndex}`}
                  dangerouslySetInnerHTML={{ __html: x[col.key] }}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Animation047;
